import { Pipe, PipeTransform } from '@angular/core';
import { cloneDeep } from 'lodash';

@Pipe({
  name: 'orderBy'
})
export class OrderByPipe implements PipeTransform {
  transform<T>(items: T[] | null | undefined, field: string, sortAsc: boolean = true): T[] {
    if (!items) {
      return [];
    }

    const itemsCopy = cloneDeep(items);

    itemsCopy.sort((a, b) => (a[field as keyof T] > b[field as keyof T] ? 1 : -1));

    if (!sortAsc) {
      itemsCopy.reverse();
    }

    return itemsCopy;
  }
}
